import React from "react";
import { Routes, Route } from "react-router-dom";
import AboutSection from "./components/About";
import HeroSection from "./components/Hero";
import "./App.css";
import ColorChange from "./components/ColorChange";
import Projects from "./components/Projects";
import Contact from "./components/Contact/index";
import Blog from "./components/Blog/index";
function App() {
  return (
    <>
      <div className="App goldenrod " id="App">
        <ColorChange />
        <Routes>
          <Route path="/">
            <Route index element={<HeroSection />} />
            <Route path="about" element={<AboutSection />} />
            <Route path="projects" element={<Projects />} />
            <Route path="contact" element={<Contact />} />
            <Route path="blog" element={<Blog />} />
          </Route>
        </Routes>
      </div>
    </>
  );
}

export default App;
